import { Grid, Box, Heading} from "@chakra-ui/react"
import CompanyProcessPlayItem from "./CompanyProcessPlayItem";
import type { CompanyProcessPlayProps } from "./types";

const CompanyProcessPlay = ({data, onPressEdit, onPressDelete,onChangeProcessStatus, setSelectedProceso}: CompanyProcessPlayProps) => {


    if(data?.length) {
        return (
            <Box w="100%" px={4}>
                <Grid templateColumns="repeat(4,1fr)" gap={4}>
                    {data?.map((item) =>  (
                        <CompanyProcessPlayItem
                            key={item.id}
                            item={item}
                            setSelectedProceso={setSelectedProceso}
                            onPressEdit={onPressEdit}
                            onPressDelete={onPressDelete}
                            onChangeProcessStatus= {onChangeProcessStatus}
                        />
                    ))}
                </Grid>
            </Box>
        )
    }

    return(
        <Box w="100%" py={4}>
            <Grid placeItems="center">
                <Heading as="h4" fontSize="xl" fontWeight={500}>Sin datos</Heading>
            </Grid>
        </Box>
    )
}

export default CompanyProcessPlay;
